import {createDivIn, createExternalImgIn, setElementOnClick} from '../../ui_utils/DomUtils.ts'
import {ViewPopup} from '../ViewPopup.ts'
import {NO_OF_STARS, type UIFeedbackFormPopupController} from './UIFeedbackFormPopupController.ts'
import Star from '@static/images/star.svg'

export class ViewPopupFeedbackForm extends ViewPopup {
    private readonly feedbackFormController: UIFeedbackFormPopupController

    constructor(feedbackFormController: UIFeedbackFormPopupController) {
        super({key: 'strings:popups.feedbackForm.title'},
            {key: 'strings:popups.feedbackForm.body'},
            () => undefined,
            () => undefined,
            true,
            {showXonHeader: true, showXButton: false, showCheckButton: false})
        this.feedbackFormController = feedbackFormController
    }

    show() {
        super.show()

        this.body.classList.add('popup-feedback-form-body')
        this.createStars()
    }

    private createStars(): void {
        const starsContainer = createDivIn(this.body, 'popup-feedback-form-stars-container')
        const stars = Array.from({length: NO_OF_STARS}, () => ViewPopupFeedbackForm.createStar(starsContainer))

        this.addStarsClickListeners(stars)

        ViewPopupFeedbackForm.animateStarsOnHover(stars)
        starsContainer.onmouseout = () => ViewPopupFeedbackForm.resetStars(stars)
    }

    private addStarsClickListeners(stars: HTMLImageElement[]): void {
        for(const [index, star] of stars.entries()) {
            setElementOnClick(star, () => {
                this.feedbackFormController.setFormData({...this.feedbackFormController.formData, rate: index + 1})
                this.feedbackFormController.nextStep()
            })
        }
    }

    private static animateStarsOnHover(stars: HTMLImageElement[]): void {
        for(const [index, star] of stars.entries()) {
            star.onmouseover = () => {
                ViewPopupFeedbackForm.resetStars(stars)
                stars.slice(0, index + 1).forEach((s) => s.style.filter = 'saturate(1)')
            }
        }
    }

    private static resetStars(stars: HTMLImageElement[]): void {
        stars.forEach((star) => star.style.filter = 'saturate(0.1)')
    }

    static createStar(container: HTMLElement, small: boolean = false, clickable: boolean = true): HTMLImageElement {
        const starImage = createExternalImgIn(container, Star, {key: 'strings:colonistCommon.utils.emptyString'}, 'popup-feedback-form-star-image')

        starImage.classList.toggle('popup-feedback-form-star-image-small', small)
        starImage.classList.toggle('popup-feedback-form-star-image-clickable', clickable)

        return starImage
    }
}
